{
  "AGENT_MGMT": {
    "HEADER": "Agents",
    "HEADER_BTN_TXT": "Add Agent",
    "LOADING": "Fetching Agent List",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Aktivni",
      "DEACTIVATED": "Deaktivirani"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Odklopi telefon",
      "API": {
        "SUCCESS_MESSAGE": "Telefon agenta je bil uspešno odklopljen",
        "ERROR_MESSAGE": "Telefona agenta ni bilo mogoče odklopiti, poskusite znova pozneje"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Ponovno aktiviraj",
      "API": {
        "SUCCESS_MESSAGE": "Agent je bil uspešno ponovno aktiviran",
        "ERROR_MESSAGE": "Agenta ni bilo mogoče ponovno aktivirati, poskusite znova pozneje"
      },
      "CONFIRM": {
        "TITLE": "Potrdite ponovno aktivacijo",
        "MESSAGE": "Ali ste prepričani, da želite ponovno aktivirati ",
        "YES": "Da, ponovno aktiviraj ",
        "NO": "Ne, prekliči "
      }
    },
    "LIST": {
      "404": "There are no agents associated to this account",
      "TITLE": "Manage agents in your team",
      "DESC": "You can add/remove agents to/in your team.",
      "NAME": "Name",
      "EMAIL": "EMAIL",
      "STATUS": "Status",
      "ACTIONS": "Actions",
      "VERIFIED": "Verified",
      "VERIFICATION_PENDING": "Verification Pending",
      "API_ALLOWED": "API dovoljen",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Add agent to your team",
      "DESC": "You can add people who will be able to handle support for your inboxes.",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "NAME": {
          "LABEL": "Agent Name",
          "PLACEHOLDER": "Please enter a name of the agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Role",
          "PLACEHOLDER": "Please select a role",
          "ERROR": "Role is required"
        },
        "EMAIL": {
          "LABEL": "Email Address",
          "PLACEHOLDER": "Please enter an email address of the agent"
        },
        "SUBMIT": "Add Agent"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent added successfully",
        "EXIST_MESSAGE": "Agent email already in use, Please try another email address",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "API": {
        "SUCCESS_MESSAGE": "Agent deleted successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      },
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "DESCRIPTION": "Agent bo takoj odjavljen, odstranjen iz vseh ekip in nabiralnikov ter ne bo več imel dostopa do tega računa.",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      }
    },
    "EDIT": {
      "TITLE": "Edit agent",
      "FORM": {
        "NAME": {
          "LABEL": "Agent Name",
          "PLACEHOLDER": "Please enter a name of the agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Vloga",
          "PLACEHOLDER": "Izberite vlogo",
          "ERROR": "Vloga je obvezna"
        },
        "EMAIL": {
          "LABEL": "Email Address",
          "PLACEHOLDER": "Please enter an email address of the agent"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Availability",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "API_ACCESS": {
          "LABEL": "Dovoli dostop do API-ja",
          "HELP": "Dostop do API-ja je privzeto onemogočen. Vklop omogoči uporabo agentovega osebnega API ključa v vseh računih, katerih član je agent. Prijava v dashboard ostaja nespremenjena."
        },
        "SUBMIT": "Edit Agent"
      },
      "BUTTON_TEXT": "Edit",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Agent updated successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Reset Password",
        "ADMIN_SUCCESS_MESSAGE": "An email with reset password instructions has been sent to the agent",
        "SUCCESS_MESSAGE": "Agent password reset successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "No results found."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "None",
      "TITLE": {
        "AGENT": "Select agent",
        "TEAM": "Select team"
      },
      "LIST": {
        "NONE": "None"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "No agents found",
          "TEAM": "No teams found"
        },
        "PLACEHOLDER": {
          "AGENT": "Search agents",
          "TEAM": "Search teams",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
